import {
  ReceivedInvoiceAutomaticStatus,
  UploadType,
} from '@/context/services/invoice/type';

export type ReadTagKind = 'ocr' | 'operator';

export type ReadTagKindParams = {
  enhanceSearch: boolean;
  uploadType?: UploadType;
  automaticStatus?: ReceivedInvoiceAutomaticStatus;
};

export const getReceivedInvoiceReadTagKind = ({
  enhanceSearch,
  uploadType,
  automaticStatus,
}: ReadTagKindParams): ReadTagKind | null => {
  if (
    !enhanceSearch ||
    uploadType === 'peppol_gateway' ||
    (uploadType === 'manual' && automaticStatus === 'manual')
  ) {
    return null;
  }
  if (uploadType === 'kihyo_plan') {
    return 'operator';
  }
  return 'ocr';
};
